// src/components/dema/CompanyFilters.tsx
import { Props } from "../../types/interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

const CompanyFilters: React.FC<Props> = ({
  searchName,
  setSearchName,
  searchLocation,
  setSearchLocation,
  locationOptions,
  employeeRange,
  setEmployeeRange
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <input
        type="text"
        placeholder={t("dema.filterByName") || "Filtrar por nombre..."}
        value={searchName}
        onChange={(e) => setSearchName(e.target.value)}
        className="p-2 border bg-[#0A1723] text-[#00FF69]
                   placeholder-gray-400 focus:outline-none
                   focus:ring-2 rounded w-full"
      />

      <select
        value={searchLocation}
        onChange={(e) => setSearchLocation(e.target.value)}
        className="p-2 border bg-[#0A1723] text-white
                   focus:outline-none focus:ring-2 rounded w-full"
      >
        <option value="">
          {t("dema.allLocations") || "Todas las ubicaciones"}
        </option>
        {locationOptions.map((loc) => (
          <option key={loc} value={loc}>
            {loc}
          </option>
        ))}
      </select>

      <select
        value={employeeRange}
        onChange={(e) => setEmployeeRange(e.target.value)}
        className="p-2 border bg-[#0A1723] text-white
                   focus:outline-none focus:ring-2 rounded w-full"
      >
        <option value="">
          {t("dema.employeeRange")}
        </option>
        <option value="0-5">0-5</option>
        <option value="6-10">6-10</option>
        <option value="11-20">11-20</option>
        <option value="21-50">21-50</option>
        <option value="51-100">51-100</option>
        <option value="100-500">100-500</option>
        <option value="500-1000">500-1000</option>
        <option value="1000+">1000+</option>
      </select>
    </div>
  );
};

export default CompanyFilters;
